import axiosPrivate from "@services/axiosPrivate"
import { UPDATE_DIAGNOSIS } from "src/constants"

export const updateDiagnosis = (data) => {
    return axiosPrivate.put(UPDATE_DIAGNOSIS, data, {
        withCredentials: true,
    })
}
